export default {
      id: "icon-lock-usage",
      viewBox: "0 0 18 24",
      url: __webpack_public_path__ + "icons.svg#icon-lock",
      toString: function () {
        return this.url;
      }
    }